import React from 'react';

import classNames from 'classnames';

import { SORT_DIRECTION } from '../../types';

import ToggleDownIcon from './icons/toggle-down-icon.svg';
import ToggleUpIcon from './icons/toggle-up-icon.svg';

import './toggle-item.scss';

interface ToggleItemProps {
  alt?: string;
  title: string;
  toggle?: boolean;
  direction?: SORT_DIRECTION;
  onChangeToggle?: (direction: SORT_DIRECTION) => void;
}

const ToggleItem: React.FC<ToggleItemProps> = ({
  alt,
  onChangeToggle,
  direction,
  title,
  toggle,
}) => (
  <div
    aria-hidden="true"
    onClick={() => {
      if (toggle && onChangeToggle) {
        onChangeToggle(direction === 'ASC' ? 'DESC' : 'ASC');
      }
    }}
    className={classNames('table-header-item', {
      'table-header-item--hoverable': toggle,
    })}
  >
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
    <div className="table-header-item__title">{title}</div>
    {toggle && (
      <div className="table-header-item__toggle">
        <img
          src={direction === 'ASC' ? ToggleUpIcon : ToggleDownIcon}
          alt={alt}
        />
      </div>
    )}
  </div>
);

export default ToggleItem;
